import { Login } from "react-admin";
import { primaryAuth } from "../../core/firebase";
import { StyledFirebaseAuth } from "react-firebaseui";
import {
  EmailAuthProvider,
  GoogleAuthProvider,
  getIdTokenResult,
  signOut,
} from "firebase/auth";

// The Seeri ID token carries a `roles` custom claim (e.g. ["ADMIN"]).
// Backoffice is an admin-only console, so we reject any login whose token
// doesn't include ADMIN — same gate the API gateway enforces server-side.
const ensureAdminOrSignOut = async (user: import("firebase/auth").User) => {
  const tokenResult = await getIdTokenResult(user, true);
  const roles = (tokenResult.claims.roles as string[] | undefined) ?? [];
  if (!roles.includes("ADMIN")) {
    await signOut(primaryAuth);
    alert("Prohibido: tu usuario no tiene rol ADMIN para acceder al backoffice.");
    return false;
  }
  return true;
};

export const CustomLoginPage = () => (
  <Login
    style={{
      boxShadow: "inset 0px 0px 400px 110px rgb(0 0 0 / 70%)",
      padding: "1rem",
    }}
  >
    <div style={{ margin: "2rem auto" }}>
      <StyledFirebaseAuth
        uiCallback={(ui) => ui.disableAutoSignIn()}
        firebaseAuth={primaryAuth}
        uiConfig={{
          signInFlow: "popup",
          signInSuccessUrl: "/",
          signInOptions: [
            GoogleAuthProvider.PROVIDER_ID,
            {
              provider: EmailAuthProvider.PROVIDER_ID,
              requireDisplayName: false,
            },
          ],
          adminRestrictedOperation: {
            status: true,
          },
          callbacks: {
            // Block redirect until we confirm the token has ADMIN; on failure
            // we sign the user out so the session isn't kept around.
            signInSuccessWithAuthResult: (authResult) => {
              const user = authResult?.user;
              if (!user) return false;
              ensureAdminOrSignOut(user).then((ok) => {
                if (ok) window.location.assign("/");
              });
              return false;
            },
          },
        }}
      />
    </div>
  </Login>
);
